import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useSWR, { SWRConfig } from 'swr';
import { useSession } from 'next-auth/react';
import { client } from './client';

const fetcher = (...args) => client.get(...args).then(res => res.data);

const globalConfig = (override = {}) => ({
  fetcher,
  shouldRetryOnError: false,
  revalidateOnFocus: false,
  ...override,
});

export const APIProvider = ({ override, children }) => {
  const config = useMemo(() => globalConfig(override), [override]);

  return <SWRConfig value={config}>{children}</SWRConfig>;
};

APIProvider.displayName = 'APIProvider';

APIProvider.propTypes = {
  children: PropTypes.node.isRequired,
  override: PropTypes.object,
};

export const useAuthenticatedSWR = (key, fetcher, options) => {
  const { data: session } = useSession();

  return useSWR(session?.user?.id ? key : null, fetcher, options);
};
